import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import { userChart } from '../../Services/AdminServices/adminAuthService';
import { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';

const LineCharts = () => {
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [totalRefferal, setTotalRefferal] = useState("");
    const handleStartDate = (e) => setStartDate(e.target.value);
    const handleEndDate = (e) => setEndDate(e.target.value);

    const getUserChart = async () => {
        try {
            let response;
            if (startDate && endDate) {
                response = await userChart(startDate, endDate);
            } else {
                response = await userChart();
            }
            setData(response?.data);
            setTotalRefferal(response)
        } catch (error) {
            console.error("Failed to fetch chart data:", error);
        }
    };


    useEffect(() => {
        // Only call API if both dates are selected or both are empty
        if ((startDate && endDate) || (!startDate && !endDate)) {
            getUserChart();
        }
    }, [startDate, endDate]);

    return (
        <div className="container mt-5">
            <div className="row justify-content-end">

                <div className="col d-flex">
                    <h5 className='me-3'>
                        <h5><span class="badge bg-theme">Total Refferals: {totalRefferal?.orders}</span></h5>
                    </h5>
                    <h5>
                        <Badge bg="danger">Total User: {totalRefferal?.users}</Badge>
                    </h5>
                </div>
                <div className="col-auto">
                    <label className='fw-bold'>Start Date</label>
                    <input value={startDate} onChange={handleStartDate} type="date" className='form-control' />
                </div>
                <div className="col-auto">
                    <label className='fw-bold'>End Date</label>
                    <input value={endDate} onChange={handleEndDate} type="date" className='form-control' />
                </div>
            </div>

            <div className="mt-4" style={{ width: '100%', height: '400px' }}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="orders" stroke="#42ACC6" />
                        <Line type="monotone" dataKey="users" stroke="#DC3545" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default LineCharts;
